// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2fes3","info":"Note_info__2cn2p","note":"Note_note__5LhWw","actions":"Note_actions__37LFc"};